import Repository from '@/repositories/Repository'
import InitData from '@/models/InitData'

class initDataRepository extends Repository {
  constructor() {
    super('/init')
  }

  async get() {
    const attributes = await super._post()

    return new InitData(attributes)
  }
}

export default initDataRepository
